module.exports = __webpack_public_path__ + "static/media/04A.df67990f.png";